import React, { useContext, useEffect, useRef, useState } from "react";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import RightArrow from "../../svg/RightArrow";
import _ from "lodash";
import axiosInstance from "../../../utils/Requests/axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import OfferCard from "./OfferCard";

function TopWebsites() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const [topWebsites, setTopWebsites] = useState(null);
  const navigate = useNavigate();
  const topWebsitesPayload = {
    start: 0,
    length: 15,
    search: {
      filters: [{ key: "PINNED", value: true }],
    },
  };

  const topWebsitesFetched = useRef(false);
  const fetchTopWebsites = () => {
    if (topWebsitesFetched.current) return;
    topWebsitesFetched.current = true;
    const payload = _.cloneDeep(topWebsitesPayload);
    const url = `offers-search`;
    axiosInstance
      .post(url, payload)
      .then((response) => {
        setTopWebsites(response?.data?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching Websites"));
      });
  };

  useEffect(() => {
    fetchTopWebsites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`w-100 pt-3 h-100 rounded cardSetting ${themeStatus?.[selectedTheme]}`}
      style={{ backgroundColor: "var(--bg-card)" }}
    >
      <div
        className="d-flex justify-content-between align-items-center px-3"
        style={{ paddingBlock: "0.4rem" }}
      >
        <h4
          className="dashboard-title-responsive p-0 mb-0"
          style={{ lineHeight: "150%" }}
        >
          {t("Top Website by Sales")}
        </h4>
        <p
          className="card-text cursor-pointer d-flex align-items-center gap-1 see-more-news"
          onClick={() => navigate("/offers-search")}
        >
          {t("See More")} <RightArrow />
        </p>
      </div>
      <div className="px-3">
        <div
          className="my-3"
          style={{
            borderBottom: `2px solid var(--border)`,
            marginLeft: "-18px",
            marginRight: "-18px",
          }}
        ></div>
      </div>

      <div
        className="articles-tab px-2 custom-scroll me-2"
        style={{ height: "calc(100% - 70px)" }}
      >
        {topWebsites?.length > 0
          ? window.innerWidth >= 1920
            ? topWebsites.map((_, index) => {
                if (index % 2 !== 0) return null;
                const offer1 = topWebsites[index];
                const offer2 = topWebsites[index + 1];
                return (
                  <div key={index} className="offer-row">
                    <div className="offer position-relative">
                      <OfferCard offer={offer1} />
                    </div>

                    <div className="vertical-divider d-none d-md-block" />

                    {offer2 && (
                      <div className="offer position-relative">
                        <OfferCard offer={offer2} />
                      </div>
                    )}
                  </div>
                );
              })
            : topWebsites.map((offer, index) => (
                <div key={index} className="offer-row">
                  <div className="offer position-relative">
                    <OfferCard offer={offer} />
                  </div>
                </div>
              ))
          : null}
      </div>
    </div>
  );
}

export default TopWebsites;
